import { ArrowLeft } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";
import { NewsItem } from "@/types/news";
import { ShareButtons } from "./ShareButtons";

interface NewsDetailHeaderProps {
    news: NewsItem;
    onCopyLink: () => void;
}

export const NewsDetailHeader = ({ news, onCopyLink }: NewsDetailHeaderProps) => {
    const { isDark } = useTheme();

    return (
        <div className="mb-12 animate-slide-up">
            {/* Back Navigation */}
            <a
                href="/noticias"
                className="inline-flex items-center gap-2 text-md text-muted-foreground hover:text-foreground mb-10 transition-colors"
            >
                <ArrowLeft className="w-4 h-4" />
                Voltar para notícias
            </a>

            {/* Author Logo */}
            {(news.newsAuthorImg || news.newsAuthorImgDark) && (
                <img
                    src={isDark && news.newsAuthorImgDark ? news.newsAuthorImgDark : news.newsAuthorImg}
                    alt={news.newsAuthor}
                    width={160}
                    height={40}
                    className="h-10 object-contain mb-6"
                    onError={e => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            )}

            {/* Title */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
                {news.newsTitle}
            </h1>

            {/* Author Info & Share */}
            <div className="flex items-center justify-between border-t border-b border-border py-6">
                <div>
                    <p className="font-semibold">{news.newsAuthor}</p>
                    <p className="text-sm text-muted-foreground">{news.newsDate}</p>
                </div>

                <div className="hidden md:block">
                    <ShareButtons
                        title={news.newsTitle}
                        url={news.newsUrl}
                        onCopyLink={onCopyLink}
                        description={news.newsContent.substring(0, 150) + "..."}
                    />
                </div>
            </div>
        </div>
    );
};
